import { useCallback } from "react"
import {
  ArrowNarrowRight,
  Button,
  ButtonProps,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { IS_MEZO_MAINNET, links } from "#/shared/constants"
import { usePosthogSwitchToTestnetEvent } from "#/shared/hooks/posthog-events"

const { MEZO_MAINNET, MEZO_TESTNET } = links

type SwitchMezoNetworkButtonProps = Omit<ButtonProps, "onClick" | "$as">

export default function SwitchMezoNetworkButton({
  children,
  ...props
}: SwitchMezoNetworkButtonProps) {
  const { emitSwitchToTestnetEvent } = usePosthogSwitchToTestnetEvent()
  const [_, theme] = useStyletron()

  const switchToTestnetEventHandler = useCallback(() => {
    if (IS_MEZO_MAINNET) return

    emitSwitchToTestnetEvent()
  }, [emitSwitchToTestnetEvent])

  return (
    <Button
      $as="a"
      href={IS_MEZO_MAINNET ? MEZO_TESTNET : MEZO_MAINNET}
      target="_self"
      size="xsmall"
      kind="tertiary"
      onClick={switchToTestnetEventHandler}
      endEnhancer={() => <ArrowNarrowRight size={theme.sizing.scale500} />}
      {...props}
    >
      {children ?? `Switch to ${IS_MEZO_MAINNET ? "Testnet" : "Mainnet"}`}
    </Button>
  )
}
